import React, { memo, ReactElement, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import i18next from 'i18next';
import { fetchFromRestAPI } from '../../util/api';
import ConfirmationModal from '../ConfirmationModal';
import { Form } from 'react-bootstrap';
import { AUTH0_ORGANIZATION_ID } from '../../config';

const RejectAppointment = (): ReactElement => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [comment, setComment] = useState('');
  const { appointmentId } = useParams<{ appointmentId: string }>();
  const handleRejectAppointment = async (): Promise<void> => {
    setIsLoading(true);
    try {
      await fetchFromRestAPI(`/api/v1/appointment/public/therapist/reject/${appointmentId}?tenant=${AUTH0_ORGANIZATION_ID}`, {
        method: 'POST',
        body: { comment: comment },
      });
      navigate('/', { replace: true });
    } catch (error) {
      console.error('Error reject appointment', error);
      window.close();
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div className="bg-white d-flex flex-row justify-content-center w-100 vh-100">
      <div className="d-flex flex-column justify-content-center align-items-center">
        <ConfirmationModal
          disableButton={isLoading}
          show={true}
          title={i18next.t('createAppointmentForm.rejectModal.title')}
          body={
            <>
              <p>{i18next.t('createAppointmentForm.rejectModal.body')}</p>
              <Form.Control as='textarea' rows={3} value={comment}
                onChange={e => comment.length < 200 ? 
                  setComment(e.target.value) : 
                  setComment(comment.slice(0, 200))
                }
              />
            </>
          }
          buttonPositive={i18next.t('createAppointmentForm.labels.reject')}
          buttonNegative={i18next.t('generic.cancel')}
          onPositive={handleRejectAppointment}
          onNegative={() => window.close()}
        />
      </div>
    </div>
  );
};

export default memo(RejectAppointment);
